import React, { useEffect, useState, useContext, useMemo } from 'react'
import { Form } from 'antd-mobile';
import { CheckCircleFill } from 'antd-mobile-icons'
import { useNavigate } from "react-router-dom"
import { UserContext } from 'utils/getContext'
import { BpmStepType } from "components/StepType/BpmStepType";
import { BpmButton } from "components/BpmButton";
import { FormFooter } from "components/FormModel/FormFooter";
import { idCardHide } from 'utils/ruleType'
import 'static/css/fromSteps.css'

/** 所有页面基础外框 */
export function FromSteps(props) {
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  const { stepNum, title, setStepNum, form, handleCheckClick, handleSubmitFormClick, getType, pageData } = props
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  function handleMineClick() {
    navigate('/mine')
  }

  /** 点击上一步按钮 */
  function handlePrevClick(stepNum) {
    if (stepNum > 0) {
      setStepNum(stepNum - 1)
    }
  }

  // 从form中获取USER_NAME
  const USER_NAME = useMemo(() => {
    const { name } = userInfo ? userInfo : {}
    const hideName = idCardHide(name, 1, name.length - 1)
    return hideName
  }, [userInfo])

  useEffect(() => {
    // 找到元素#swb-header
    const header = document.getElementById('swb-header')
    const headerLoading = document.getElementById('#swb-loading')
    const username = document.getElementsByClassName('username')
    /**显示header */
    const showHeader = () => {
      header.style.visibility = 'visible'
      header.style.maxHeight = 'inherit'
      header.style.position = 'relative'
      header.style.zIndex = '999'
    }
    //**显示header加载 */
    const showHeaderLoading = () => {
      headerLoading.style.visibility = 'visible'
    }
    /**隐藏header */
    const hideHeader = () => {
      header.style.visibility = 'hidden'
      header.style.maxHeight = '0'
      header.style.position = 'relative'
      header.style.zIndex = '999'
    }
    //**隐藏header加载 */
    const hideHeaderLoading = () => {
      headerLoading.style.visibility = 'hidden'
    }

    if (headerLoading) {
      showHeaderLoading()
    }
    if (header) {
      showHeader()
      // 如果有username，且username的style为display: none，设置username的innerHTML为USER_NAME，
      if (username[0]) {
        if (USER_NAME) {
          username[0].style.display = 'block'
          username[0].innerHTML = USER_NAME
        } else {
          username[0].style.display = 'none'
          username[0].innerHTML = '用户名'
        }
      }
    } else {
      console.log('header is null')
    }
    // 离开时
    return () => {
      if (header) {
        hideHeader()
      }
      if (headerLoading) {
        hideHeaderLoading()
      }
    }
  }, [USER_NAME])


  /** 获取表单页面信息 */
  function getPageInfo(parm) {
    return <Form
      layout='horizontal'
      form={form}
      onFinish={(values) => handleSubmitFormClick(setLoading)}
      onFinishFailed={(errorInfo) => console.log('Failed:', errorInfo)}
      footer={
        <>
          {
            handleCheckClick && (
              <BpmButton
                loading={loading}
                type="button"
                content={'查看社保缴费情况'}
                onClick={() => handleCheckClick(stepNum)}
                className='stepBut'
              />
            )
          }
          {
            stepNum > 1 && stepNum < title.length && (
              <BpmButton
                loading={loading}
                type="button"
                content={'上一步'}
                onClick={() => handlePrevClick(stepNum)}
                className='stepBut'
              />
            )
          }
          <BpmButton
            loading={loading}
            content={stepNum === title.length - 1 ? '提交' : '下一步'}
          />
          <FormFooter />
        </>
      }
    >
      {
        parm.map((pageItem, index) =>
          <div key={index}>
            <div className='formCut'></div>
            <Form.Header>{pageItem.title}</Form.Header>
            {pageItem.arr.map((item, index) => getType(item, index))}
          </div>
        )
      }
    </Form >
  }

  return (
    <div className='fromSteps'>
      <BpmStepType stepNum={stepNum} title={title} />
      <div className='declarationBody'>
        {
          stepNum === pageData.length + 1
            ? (
              <div>
                <div className='submitSuccess'>
                  <CheckCircleFill
                    fontSize={60}
                    color='#11d157'
                  /><br />
                </div>
                <p className='submitCont' >您的办件信息已提交</p>
                <p className='submitCont' >后续可在“
                  <span onClick={handleMineClick}>我的</span>
                  ”查看办件审批进度</p>
              </div>
            )
            :
            (
              <div>
                {getPageInfo(pageData[stepNum - 1])}
              </div>
            )
        }
      </div>
    </div>
  )
}